export default __webpack_public_path__ + "static/1435-05a9a8ef73c803a91cb6d0b2a8cf9834.gif";